import { render, staticRenderFns } from "./center-container.vue?vue&type=template&id=e143ec6c&scoped=true&"
import script from "./center-container.vue?vue&type=script&lang=js&"
export * from "./center-container.vue?vue&type=script&lang=js&"
import style0 from "./center-container.vue?vue&type=style&index=0&id=e143ec6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e143ec6c",
  null
  
)

export default component.exports